declare var process: any;

const ENV = process.env.ENV;
const AUTH_CLIENT_ID = process.env.AUTH_CLIENT_ID;
const AUTH_CLIENT_SECRET = process.env.AUTH_CLIENT_SECRET;
const MS_AUTH_CLIENT_ID = process.env.MS_AUTH_CLIENT_ID;
const MS_AUTH_REDIRECT_URL = process.env.MS_AUTH_REDIRECT_URL;
const API_URI = process.env.API_URI;

export const environment = {
  production: ENV !== 'dev',
  zoniferoServicesAuth: {
    accessTokenUrl: `https://${API_URI}/oauth/token/`,
    clientId: AUTH_CLIENT_ID,
    clientSecret: AUTH_CLIENT_SECRET,
    confirmPasswordReset: `//${API_URI}/accounts/password/reset/confirm/`,
    passwordResetUrl: `//${API_URI}/accounts/password/reset/`,
  },
  microsoftAuth: {
    MSAuthUrl: 'https://login.microsoftonline.com/common/oauth2/authorize',
    clientId: MS_AUTH_CLIENT_ID,
    redirectUrl: MS_AUTH_REDIRECT_URL,
    responseType: 'code',
    resource: 'https://graph.microsoft.com',
    ZSAuthUrl: `https://${API_URI}/oauth/token/microsoft/web/`,
  },
  endpoints: {
    areasToUpdate: `//${API_URI}/apiWeb/1/areasToUpdate/`,
    areaAccept: `//${API_URI}/apiWeb/1/areaAccept/`,
    areaDetails: `//${API_URI}/apiWeb/1/areaDetails/`,
    areas: `//${API_URI}/apiWeb/1/areas/`,
    areaSummaries: `//${API_URI}/apiWeb/1/areaSummaries/`,
    clientDetails: `//${API_URI}/apiWeb/1/clientDetails/`,
    clients: `//${API_URI}/apiWeb/1/clients/`,
    employeeAdd: `//${API_URI}/apiWeb/1/employeeAdd/`,
    employeeDetails: `//${API_URI}/apiWeb/1/employeeDetails/`,
    employeeUpdate: `//${API_URI}/apiWeb/1/employeeUpdate/`,
    employeeDelete: `//${API_URI}/apiWeb/1/employeeDelete/`,
    employees: `//${API_URI}/apiWeb/1/employees/`,
    progress: `//${API_URI}/apiWeb/1/progress/`,
    taskAddInfo: `//${API_URI}/apiWeb/1/taskAddInfo/`,
    taskAdd: `//${API_URI}/apiWeb/1/taskAdd/`,
    taskDetails: `//${API_URI}/apiWeb/1/taskDetails/`,
    taskUpdate: `//${API_URI}/apiWeb/1/taskUpdate/`,
    taskDelete: `//${API_URI}/apiWeb/1/taskDelete/`,
    tasks: `//${API_URI}/apiWeb/1/tasks/`,
    translations: `//${API_URI}/apiWeb/1/translations/`,
  },
};



// WEBPACK FOOTER //
// ./src/environment.ts